import { enumType } from '@shared/core/types/common';

enum APP_MODE {
    DEFAULT = OLO.Enums.APP_MODE.DEFAULT,
    ORDERING_ONLY = OLO.Enums.APP_MODE.ORDERING_ONLY,
    LOYALTY_ONLY = OLO.Enums.APP_MODE.LOYALTY_ONLY,
}

export const appModeEnum = enumType('APP_MODE', APP_MODE);
